<h1 mat-dialog-title>{{ 'website.users.table.actions.are_you_sure_you_want_to_deactivate_users' | translate: { count: data.count } }}</h1>
<div mat-dialog-actions>
  <button mat-button (click)="onButtonClick('no')">{{ 'website.users.table.actions.no' | translate }}</button>
  <button mat-button cdkFocusInitial (click)="onButtonClick('yes')">{{ 'website.users.table.actions.yes' | translate }}</button>
</div>
